import { Box, Button, Stack, Typography } from "@mui/material"
import { useGetTrainingUrlQuery } from "../../api/ducApiSlice";
import { useUserInfoQuery } from "../../api/userApiSlice";
import { useEffect, useState, useRef } from "react"


const Assessment = () => {
    // @ts-ignore
    const trainingUrlEnv = window.env.trainingUrl
    const hasSetUrl = useRef(false);
    const hasRefetched = useRef(false);

    // Use more conservative caching options
    const { data: userData, refetch: refetchUser } = useUserInfoQuery({}, {
        // Use more conservative caching options to prevent infinite loops
        refetchOnMountOrArgChange: false,
        refetchOnFocus: false,
        refetchOnReconnect: false
    });

    const username = userData?.username;

    // Skip if username is not available
    const { data: trainingUrl } = useGetTrainingUrlQuery({ username }, {
        skip: !username,
        // Use more conservative caching options
        refetchOnMountOrArgChange: false,
        refetchOnFocus: false,
        refetchOnReconnect: false
    });

    const [url, setUrl] = useState("");

    // Replace aggressive polling with a single refetch
    useEffect(() => {
        if (username && !hasRefetched.current) {
            // Refetch once when username is available
            refetchUser();
            hasRefetched.current = true;
        }
    }, [username, refetchUser]);

    // Only set URL once to prevent unnecessary re-renders
    useEffect(() => {
        if (!hasSetUrl.current) {
            if(typeof trainingUrl === "string"){
                setUrl(trainingUrl);
            } else {
                setUrl(trainingUrlEnv);
            }
            hasSetUrl.current = true;
        }
    }, [trainingUrl, trainingUrlEnv])

    const handleClick = () => {
        window.open(url,"_self")
    }

    return (
        <Stack alignItems="center" gap={3} marginTop="100px">
            <Box maxWidth="800px">
                <Typography textAlign="center">You have been redirected to new tab to complete your training and assessment. Please come back to this page when training is complete.
                    If you cannot locate the assessment link, the button below </Typography>
            </Box>
            <Button variant="primary"
                onClick={handleClick}>
                Go to Training Page
            </Button>
        </Stack>


    )
}

export default Assessment
